import React from 'react';
import { useTranslation } from 'react-i18next';
import MyInvestment from './MyInvestment';
import { InvestmentPackage } from '@/api/Admin/type';

interface InvestmentStats {
  totalPackages: number;
  totalInvestment: number;
  totalProfit: number;
  total_overdue: number;
}

interface InvestmentTabProps {
  stats?: InvestmentStats;
  investments?: InvestmentPackage[];
  loading?: boolean;
}

const InvestmentTab: React.FC<InvestmentTabProps> = ({ stats, investments, loading }) => {
  const { t } = useTranslation();
  const statsCards = [
    {
      title: t('investorDetail.investment.totalPackages', 'Tổng số gói'),
      value: `${stats?.totalPackages} ${t('investorDetail.investment.packages', 'gói')}`,
    },
    {
      title: t('investorDetail.investment.totalInvestment', 'Tổng vốn đầu tư'),
      value: `${stats?.totalInvestment.toLocaleString('vi-VN', { maximumFractionDigits: 0 })} đ`,
    },
    {
      title: t('investorDetail.investment.totalProfit', 'Tổng lãi đã nhận'),
      value: `${stats?.totalProfit.toLocaleString('vi-VN', { maximumFractionDigits: 0 })} đ`,
    },
    {
      title: t('investorDetail.investment.totalOverdue', 'Tổng nợ quá hạn'),
      value: `${stats?.total_overdue.toLocaleString('vi-VN', { maximumFractionDigits: 0 })} đ`,
    },
  ];

  return (
    <div className="space-y-6 flex flex-col">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {statsCards.map((card, index) => (
          <div
            key={index}
            className="bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-md p-5"
          >
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
              {card.title}
            </p>
            <p className="text-xl font-semibold text-gray-900 dark:text-white">
              {card.value}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
          {t('investorDetail.investment.history', 'Lịch sử đầu tư')}
        </h3>
        <MyInvestment 
          investments={investments || []} 
          loading={loading} 
          allowRedirect={false} 
          showScheduleButton={true} 
        />
      </div>
    </div>
  );
};

export default InvestmentTab;
